// MLS-COMPONENT-QC-001 — component-level QC helpers for dual TAX+MLS orders.
export const COMPONENT_LABELS = { tax: 'TAX', mls: 'MLS' };

// Component currently awaiting QC on a dual order ('tax' | 'mls' | null). Order-level QC (status qc_review) wins.
export const qcComponentOf = (order) => {
  if (!order || order.status === 'qc_review') return null;
  if (order.qc_component) return order.qc_component;
  const comps = order.components || {};
  return ['tax', 'mls'].find((c) => comps[c]?.qc_status === 'pending_review') || null;
};

// Endpoint for a QC decision: component-scoped when the item is a component, order-level otherwise.
export const qcActionPath = (order, action) => {
  const comp = qcComponentOf(order);
  return comp ? `/orders/${order.id}/components/${comp}/qc-${action}` : `/orders/${order.id}/qc-${action}`;
};

// QC-REVIEW-UI-002 — the single "return for correction" request used by the QC flow
// (QCInlineActions) and the admin QC Actions banner. Same endpoint, same body.
export const postQcReturn = (order, { category, errorType, notes, evidenceFileIds, severity, affectedComponents }) =>
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api${qcActionPath(order, 'return')}`, {
    method: 'POST',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({
      rejection_category: category,
      error_type: errorType || null,
      rejection_reason: notes,
      evidence_file_ids: evidenceFileIds || [],
      severity: severity || null,
      affected_components: affectedComponents || null,
    }),
  });
